module.exports = __webpack_public_path__ + "static/media/icon-piece-3.cb908bcd.png";